export const initLoginWithAppTokenPage = () => {
    fetch(window.ssoLoginWithAppTokenUrl)
        .then(response => {
            if(response.redirected){
                document.querySelector(".in-app-logging-in").hidden = true;
                document.querySelector(".in-app-logged-in").hidden = false;
                window.location = response.url;
            }

            if(response.status == 401){
                document.querySelector(".in-app-logging-in").hidden = true;
                document.querySelector(".dot-loader").hidden = true;
                document.querySelector(".in-app-log-in-fail").hidden = false;
            }
        })
        .catch(error => {
            console.log(error);
            document.querySelector(".in-app-logging-in").hidden = true;
            document.querySelector(".in-app-log-in-fail").hidden = false;
        })
}